import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import { toast } from 'react-toastify'
import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'
import { PasajeroEdicion } from './PasajeroEdicion'
import { PasajeroLectura } from './PasajeroLectura'
import ModalAddFile from '../Shared/ModalAddFile'
import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import ModalSelectorAirport from '../Shared/ModalSelectorAirport'
import SelectorInput from '../Shared/SelectorInput'
import Comentarios from '../Shared/Comentarios'
import AttachedFilesBox from '../Shared/AttachedFilesBox'

import { isAllowedToViewComponent } from '../../utils/helpers';

import {
    displayModalAddFile,
    downloadFile,
    selectFromSelector,
    showModalSelector,
    showModalSelectorUrlAirports,
} from '../../actions/common'


import {
    updateInputs,
    addOrigen,
    addDestino,
    addPasajero,
    editPassportFile,
    addCencoSolicitud,
    removeCenco,
    addTrayecto,
    removeTrayectos,
    enviarComentario,
    editarComentario,
    eliminarComentario,
    removeSolicitudTiqutesAereos,
    addFileAdjunto
} from '../../actions/tiquetesaereo'

import { validateCaducidadPasaporte } from '../../actions/creaciontiqueteaereo'
import BoxButton from '../Layout/BoxButton';
import ModalSelectVersion from './ModalSelectVersion';


class General extends Component {
    handleOpenSelector = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/auxiliares', fn)
    }

    handleOpenSelectorAddPasajero = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector(() => this.props.addPasajero(payload))
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/ldap', fn)
    }

    handleOpenSelectorResponsableCenco = (path, index) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' },
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1', payload)

            this.props.updateInputs(`solicitud.viaje.cencos.${index}.id`, null)
			this.props.updateInputs(`solicitud.viaje.cencos.${index}.codigo`, null)
			this.props.updateInputs(`solicitud.viaje.cencos.${index}.descripcion`, null)
			this.props.updateInputs(`solicitud.viaje.cencos.${index}.responsable_id`, a.id)
			this.props.updateInputs(`solicitud.viaje.cencos.${index}.pivot.cenco_id`, null)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/cencos', fn)
    }


    handleOpenSelectorAddCenco = (list, index) => {
        let columns = [
            { id: 1, caption: 'Codigo', value: 'codigo', width: '30%' },
            { id: 2, caption: 'Descripcion', value: 'descripcion', width: '70%' }
        ]

        const cenco = this.props.tiquetesaereo.getIn(['viaje', 'cencos', index]).toJS()

        const payload = {}
        const fn = (a) => {
            const index = this.props.tiquetesaereo.getIn(['viaje', 'cencos']).findIndex(c => c.get('id') == a.id)
            if (index >= 0) {
                toast.warn(`El cenco ${a.codigo} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
            } else {
                cenco.id = a.id,
                cenco.codigo = a.codigo,
                cenco.descripcion = a.descripcion

                payload.path = list
                payload.value = cenco
                this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1', payload)
                this.props.updateInputs(`solicitud.viaje.cencos.${index}.pivot.cenco_id`, a.id)
            }
        }
        const customFilter = { column: 'T0.responsable_id', operator: '===', value: this.props.tiquetesaereo.getIn(['viaje', 'cencos', index, 'usuario', 'id']), comparison: 'string' }
        console.log(customFilter)
        this.props.showModalSelector('Listado de CENCOS', columns, '/cencos', fn, customFilter)
	}

    handleOpenSelectorUbicacionOrigen = (path) => {
        let columns = [
            { id: 1, caption: 'Código', value: 'code', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'name', width: '35%' },
            { id: 3, caption: 'País', value: 'country_name', width: '35%' }
        ]
        const payload = {}
        const fn = (a, query) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector(() => this.props.addOrigen(payload, query))
        }
        this.props.showModalSelectorUrlAirports('Listado de aeropuertos', columns, '/aeropuertos', fn)
    }

    handleOpenSelectorUbicacionDestino = (path) => {
        let columns = [
            { id: 1, caption: 'Código', value: 'code', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'name', width: '35%' },
            { id: 3, caption: 'País', value: 'country_name', width: '35%' }
        ]
        const payload = {}
        const fn = (a,query) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector(() => this.props.addDestino(payload, query))
        }
        this.props.showModalSelectorUrlAirports('Listado de aeropuertos', columns, '/aeropuertos', fn)
    }

    handleAeropuerto = (index, tipo, value) => {
        if (tipo === 'origen') {
            this.props.updateInputs(`solicitud.viaje.trayectos.${index}.origen`, value)
            this.props.updateInputs(`solicitud.viaje.trayectos.${index}.aeropuerto_origen`, value)
        }

        if (tipo === 'destino') {
            this.props.updateInputs(`solicitud.viaje.trayectos.${index}.destino`, value)
            this.props.updateInputs(`solicitud.viaje.trayectos.${index}.aeropuerto_destino`, value)
        }
    }

    onResetAeropuerto = (tipo, index) => {
        if (tipo == 'origen') {
            this.props.updateInputs(`solicitud.viaje.trayectos.${index}.origen`, null)
            this.props.updateInputs(`solicitud.viaje.trayectos.${index}.aeropuerto_origen`, null)
        }

        if (tipo == 'destino') {
            this.props.updateInputs(`solicitud.viaje.trayectos.${index}.destino`, null)
            this.props.updateInputs(`solicitud.viaje.trayectos.${index}.aeropuerto_destino`, null)
        }
    }




	render() {

        const { id, tiquetesaereo, aprobadores, user, comentario , enums,flagAdjunto,adjuntos} = this.props

        const tipos_identificacion = enums.tipos_identificacion
        if (!id) return null
        const can_edit = isAllowedToViewComponent("solicitante", tiquetesaereo) ||isAllowedToViewComponent("aprobador_primer_nivel", aprobadores)

        const accionesTrayectos = [
            <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" title="Adicionar trayecto" onClick={ () => this.props.addTrayecto() } disabled={(tiquetesaereo.getIn(['viaje', 'tipo_trayecto']) != 3)}  />,
            <BoxButton key="ba[1][1]" size={14} contrast name="trash" title="Eliminar trayecto" onClick={ () => this.props.removeTrayectos() } danger disabled={(tiquetesaereo.getIn(['viaje', 'tipo_trayecto']) != 3)}/>,
        ]

        const actionsDistribucionCencos = [
            <BoxButton key="ba[2][0]" size={14} contrast name="plus-circle" title="Nuevo" onClick={ () => this.props.addCencoSolicitud() } />,
            <BoxButton key="ba[2][1]" size={14} contrast name="trash" title="Eliminar" onClick={ () => this.props.removeCenco() } danger />,
        ]

        const asistencia_vajero = tiquetesaereo.getIn(['viaje', 'asistencia_viajero'])

        const disabled_comment = (tiquetesaereo.get('estado') === 0 || tiquetesaereo.get('estado') === 7);

        return (
        <Fragment>

            <BoxSection title="Información básica">

                <div className="row">
                    {
                        isAllowedToViewComponent('administrador', tiquetesaereo.get('solicitante')) && tiquetesaereo.get('estado') != 0 && tiquetesaereo.get('estado') != 7 ? (

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Solicitante</label>
                                    <SelectorInput value={ tiquetesaereo.getIn(['solicitante', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`solicitud.solicitante`) } onReset={ () => this.props.updateInputs(`solicitud.solicitante`, null) } />
                                </div>
                            </div>

                        ):(

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Solicitante</label>
                                    <input className="form-control input-sm" type="text" value={ tiquetesaereo.getIn(['solicitante', 'fullname']) || '' } disabled/>
                                </div>
                            </div>


                        )
                    }

                    <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">Correo</label>
                            <input className="form-control input-sm" value={ tiquetesaereo.getIn(['solicitante', 'email']) || '' } disabled />
                        </div>
                    </div>

                    <div className="col-md-1">
                        <div className="form-group">
                            <label className="control-label">Extensión</label>
                            <input className="form-control input-sm" type="text" value={ tiquetesaereo.getIn(['solicitante', 'extension']) || '' }  disabled/>
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Área</label>
                            <input className="form-control input-sm" type="text" value={ tiquetesaereo.getIn(['solicitante', 'area', 'nombre']) || '' } disabled/>
                        </div>
                    </div>

                </div>

                <div className="row">

                    {
                        isAllowedToViewComponent('administrador', tiquetesaereo.get('responsable_compras')) && tiquetesaereo.get('estado') != 0 && tiquetesaereo.get('estado') != 7 ? (

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Responsable de compras</label>
                                    <SelectorInput value={ tiquetesaereo.getIn(['responsable_compras', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`solicitud.responsable_compras`) } onReset={ () => this.props.updateInputs(`solicitud.responsable_compras`, null) } />
                                </div>
                            </div>

                        ):(

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Responsable de compras</label>
                                    <input className="form-control input-sm" type="text" value={ tiquetesaereo.getIn(['responsable_compras', 'fullname']) || '' } disabled/>
                                </div>
                            </div>


                        )
                    }

                    <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">Correo</label>
                            <input className="form-control input-sm" value={ tiquetesaereo.getIn(['responsable_compras', 'email']) || '' } disabled />
                        </div>
                    </div>

                    <div className="col-md-1">
                        <div className="form-group">
                            <label className="control-label">Extensión</label>
                            <input className="form-control input-sm" type="text" value={ tiquetesaereo.getIn(['responsable_compras', 'extension']) || '' }  disabled/>
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Fecha solicitud</label>
                            <input className="form-control input-sm" value={ moment(tiquetesaereo.getIn(['created_at'])).format('DD/MM/YYYY')  || ''  } disabled />
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">No. Solicitud</label>
                            <input className="form-control input-sm" value={ tiquetesaereo.get('id') || '' } disabled />
                        </div>
                    </div>


                </div>

            </BoxSection>

            <BoxSection title="Información del viaje">

                <div className="row">

                    <div className="col-md-4">
                        <div className="form-group">
                            <label className="control-label">Motivo del viaje</label>
                            <input className="form-control input-sm" type="text" value={tiquetesaereo.get('proyecto_evento') || ''}
                                    onChange={e => this.props.updateInputs('solicitud.proyecto_evento', e.target.value)}
                                    disabled={!can_edit || tiquetesaereo.get('estado') > 3 || tiquetesaereo.get('estado') == 0} />
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Tipo de viaje</label>
                            <select className="form-control input-sm" value={tiquetesaereo.getIn(['viaje', 'tipo_viaje']) || ''}
                                    onChange={e => this.props.updateInputs('solicitud.viaje.tipo_viaje', e.target.value)}
                                    disabled={!can_edit || tiquetesaereo.get('estado') > 3 || tiquetesaereo.get('estado') == 0}>
                                <option value="1">Nacional</option>
                                <option value="2">Internacional</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Tipo de trayectoria</label>
                            <select className="form-control input-sm" value={tiquetesaereo.getIn(['viaje','tipo_trayecto']) || ''}
                                    onChange={e => this.props.updateInputs('solicitud.viaje.tipo_trayecto', e.target.value)}
                                    disabled={!can_edit || tiquetesaereo.get('estado') > 3 || tiquetesaereo.get('estado') == 0} >
                                <option value="1">Ida y vuelta</option>
                                <option value="2">Solo ida</option>
                                <option value="3">Multiples ciudades</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Cantidad de pasajeros</label>
                            <input className="form-control input-sm" type="number" min="1" value={tiquetesaereo.getIn(['viaje', 'cant_pasajeros']) || ''}
                                    onChange={e => this.props.updateInputs('solicitud.viaje.cant_pasajeros', e.target.value)}
                                    disabled={!can_edit || tiquetesaereo.get('estado') > 3 || tiquetesaereo.get('estado') == 0} />
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div style={{ marginTop: '22px' }}>
                            <input type="checkbox" id="assist" checked={asistencia_vajero}
                                onChange={e => this.props.updateInputs(`solicitud.viaje.asistencia_viajero`, e.target.checked)}
                                disabled={tiquetesaereo.getIn(['viaje', 'tipo_viaje']) == 1 || (!can_edit || tiquetesaereo.get('estado') > 3 || tiquetesaereo.get('estado') == 0)} />
                            <label style={{ margin: '0 0 0 7px' }} className="control-label" htmlFor="assist" >Asistencia al viajero</label>
                        </div>
                    </div>


                </div>
            </BoxSection>

            <div className="separator"></div>
            {can_edit && tiquetesaereo.get('estado') < 4 && tiquetesaereo.get('estado') != 0 ?
                <BoxSection title="Trayectos" actions={accionesTrayectos}>
                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">
                        <thead>
                            <tr>
                                <th width="20px">
                                    <input type="checkbox" style={{ verticalAlign: 'middle' }} />
                                </th>
                                <th style={{ width: '23%' }}>Origen</th>
                                {(tiquetesaereo.getIn(['viaje', 'tipo_trayecto']) == 3) ? (
                                    <Fragment>
                                        <th style={{ width: '13%' }}>Fecha</th>
                                        <th style={{ width: '10%' }}>Hora</th>
                                    </Fragment>
                                ) : (
                                        <Fragment>
                                            <th style={{ width: '13%' }}>Fecha ida</th>
                                            <th style={{ width: '10%' }}>Hora ida</th>
                                        </Fragment>
                                    )}
                                <th style={{ width: '23%' }}>Destino</th>
                                {(tiquetesaereo.getIn(['viaje', 'tipo_trayecto']) == 1) && (
                                    <Fragment>
                                        <th style={{ width: '13%' }}>Fecha regreso</th>
                                        <th style={{ width: '10%' }}>Hora regreso</th>
                                    </Fragment>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {tiquetesaereo.getIn(['viaje', 'trayectos']).map((t, i) => {
                                return (
                                    <tr key={`t[${t.get('guid')}${i}]`} className={t.get('selected') ? 'info' : ''}>
                                        <td><input type="checkbox" style={{ verticalAlign: 'middle' }} value={t.get('selected')} onChange={e => this.props.updateInputs(`solicitud.viaje.trayectos.${i}.selected`, e.target.value)} disabled={i == 0} /></td>
                                        <td>
                                            <SelectorInput value={t.get('origen') ? `${t.get('origen')} ${t.get('aeropuerto_origen')}` : ''} onClick={() => this.handleOpenSelectorUbicacionOrigen(`solicitud.viaje.trayectos.${i}`)} onReset={() => this.onResetAeropuerto('origen', i)} />
                                            {/* <input className="form-control input-sm" type="text" value={ t.get('origen') || '' } onChange={ e => this.handleAeropuerto(i, 'origen', e.target.value)} /> */}
                                        </td>
                                        <td><input className="form-control input-sm" type="date" value={t.get('fecha_ida') ? moment(t.get('fecha_ida')).format('YYYY-MM-DD') : ''} onChange={e => this.props.updateInputs(`solicitud.viaje.trayectos.${i}.fecha_ida`, e.target.value)} /></td>
                                        <td><input className="form-control input-sm" type="time" value={t.get('hora_ida') || ''} onChange={e => this.props.updateInputs(`solicitud.viaje.trayectos.${i}.hora_ida`, e.target.value)} /></td>
                                        <td>
                                            <SelectorInput value={t.get('destino') ? `${t.get('destino')} ${t.get('aeropuerto_destino')}` : ''} onClick={() => this.handleOpenSelectorUbicacionDestino(`solicitud.viaje.trayectos.${i}`)} onReset={() => this.onResetAeropuerto('destino', i)} />
                                        </td>
                                        {(tiquetesaereo.getIn(['viaje', 'tipo_trayecto']) == 1) && (
                                            <Fragment>
                                                <td>
                                                    <input className="form-control input-sm" type="date" value={t.get('fecha_regreso') ? moment(t.get('fecha_regreso')).format('YYYY-MM-DD') : ''} onChange={e => this.props.updateInputs(`solicitud.viaje.trayectos.${i}.fecha_regreso`, e.target.value)} />
                                                </td>
                                                <td>
                                                    <input className="form-control input-sm" type="time" value={t.get('hora_regreso') || ''} onChange={e => this.props.updateInputs(`solicitud.viaje.trayectos.${i}.hora_regreso`, e.target.value)} />
                                                </td>
                                            </Fragment>
                                        )}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </BoxSection> :
                <BoxSection title="Trayectos">
                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">
                        <thead>
                            <tr>
                                <th style={{ width: '23%' }}>Origen</th>
                                {(tiquetesaereo.getIn(['viaje', 'tipo_trayecto']) == 3) ? (
                                    <th style={{ width: '23%' }}>Fecha viaje</th>
                                ) : (
                                    <th style={{ width: '23%' }}>Fecha ida</th>
                                )}
                                <th style={{ width: '23%' }}>Destino</th>
                                {(tiquetesaereo.getIn(['viaje', 'tipo_trayecto']) == 1) && (
                                    <th style={{ width: '23%' }}>Fecha regreso</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {tiquetesaereo.getIn(['viaje', 'trayectos']).map((t,i) => {
                                return (
                                    <tr key={ `tr[0][${i}]` } className={ t.get('selected') ? 'info' : '' }>
                                        <td>{ `${t.get('origen')}-${t.get('aeropuerto_origen')}` }</td>
                                        {/* <td>{ `${t.get('origen')}` }</td> */}
                                        <td>{ moment(t.get('fecha_ida')).format('DD/MM/YYYY hh:mm A') }</td>
                                        <td>{ `${t.get('destino')}-${t.get('aeropuerto_destino')}`}</td>
                                        {/* <td>{ `${t.get('destino')}`}</td> */}
                                        {(tiquetesaereo.getIn(['viaje', 'tipo_trayecto']) == 1) && (
                                            <td>
                                                {moment(t.get('fecha_regreso')).format('DD/MM/YYYY hh:mm A') }
                                            </td>
                                        )}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </BoxSection> }

           <div className="separator"></div>
           {can_edit && tiquetesaereo.get('estado') < 3 && tiquetesaereo.get('estado') != 0 ?
            <BoxSection title="Distribución de centros de costos" actions={actionsDistribucionCencos}>
                <div className="box-content" >
                    <table className="table table-condensed">
                        <thead>
                            <tr>
                                <th style={{ width: '20px' }} ></th>
                                <th>Ordenador del gasto</th>
                                <th>Centro de costo</th>
                                <th>Porcentaje</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                tiquetesaereo.getIn(['viaje', 'cencos']).count() > 0 ? (tiquetesaereo.getIn(['viaje', 'cencos']).map((x, n) => {
                                    return (
                                        <tr key={`tr[${x.get('id') ? x.get('id') : x.get('guid')}]`} className={x.get('selected') ? 'info-dark' : ''} >
                                            <td ><input type="checkbox" style={{ marginTop: '6px' }} checked={x.get('selected') || false} onChange={(e) => this.props.updateInputs(`solicitud.viaje.cencos.${n}.selected`, e.target.checked)} /></td>
                                            <td>
                                                <SelectorInput value={x.getIn(['usuario', 'fullname']) || ''} onClick={() => this.handleOpenSelectorResponsableCenco(`solicitud.viaje.cencos.${n}.usuario`, n)} onReset={() => this.props.updateInputs(`solicitud.viaje.cencos.${n}.usuario`, null)} />
                                            </td>
                                            <td>
                                                {
                                                    x.get('usuario') ? (
                                                        <SelectorInput value={x.get('codigo')} onClick={() => this.handleOpenSelectorAddCenco(`solicitud.viaje.cencos.${n}`, n)} onReset={() => this.props.updateInputs(`solicitud.viaje.cencos.${n}`, null)} />
                                                    ) : (
                                                            <input className="form-control input-sm" placeholder="Seleccione un responsable del cenco" disabled />
                                                        )
                                                }
                                            </td>
                                            <td>
                                                <input type="number" className="form-control input-sm" placeholder="Porcentaje" value={x.getIn(['pivot', 'porcentaje']) ? x.getIn(['pivot', 'porcentaje']) : 0} onChange={(e) => this.props.updateInputs(`solicitud.viaje.cencos.${n}.pivot.porcentaje`, e.target.value)} disabled={x.get('usuario') == null} />
                                            </td>
                                            <td style={{ width: '20px', verticalAlign: 'middle' }}>%</td>
                                        </tr>
                                    )
                                })) : (
                                        <tr>
                                            <td colSpan={6} style={{ textAlign: 'center' }}>
                                                Para agregar un centro de costo haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span>
                                            </td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </table>
                </div>
            </BoxSection> :
            <BoxSection title="Distribución de centros de costos">
                <div className="box-content" >
                    <table className="table table-condensed">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Ordenador del gasto</th>
                                <th>Centro de costo</th>
                                <th>Porcentaje</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            tiquetesaereo.getIn(['viaje', 'cencos']).count() > 0 ? (tiquetesaereo.getIn(['viaje', 'cencos']).map((x, n) => {
                                return (
                                    <tr key={ `tr[${ x.getIn(['pivot', 'id']) ? x.getIn(['pivot', 'id']) : x.getIn(['pivot', 'guid']) }]` }  className={ x.get('selected') ? 'info-dark' : '' } >
                                        <td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ n + 1 }</span></td>
                                        <td>
                                            <input className="form-control input-sm" value={ x.getIn(['usuario', 'fullname'] || '')} disabled/>
                                        </td>
                                        <td style={{ width: '55%' }} >
                                            <input className="form-control input-sm" value={x.get('codigo') || '' } disabled/>
                                        </td>
                                        <td>
                                            <input type="number" className="form-control input-sm" placeholder="Porcentaje" value={ x.getIn(['pivot', 'porcentaje']) ? x.getIn(['pivot', 'porcentaje']) : 0 } disabled />
                                        </td>
                                        <td style={{ width: '20px', verticalAlign: 'middle' }}>%</td>
                                    </tr>
                                )
                            })) : (
                                    <tr>
                                        <td style={{ textAlign: 'center' }}>
                                            No hay distribución de centro de costos para esta solicitud
                                        </td>
                                    </tr>
                            )
                        }
                        </tbody>
                    </table>
                </div>
            </BoxSection>}

            <div className="separator"></div>

            <BoxSection title="Observaciones">
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <textarea type="text" className="form-control input-sm" rows={4} value={ tiquetesaereo.getIn(['observaciones']) || '' }
                                onChange={(e) => this.props.updateInputs(`solicitud.observaciones`, e.target.value)}
                                disabled={!can_edit || tiquetesaereo.get('estado') > 3 || tiquetesaereo.get('estado') == 0} />
                        </div>
                    </div>
                </div>
            </BoxSection>

            <div className="separator"></div>

            <Comentarios
                    foros = { tiquetesaereo.get('foros') }
                    comentario = { this.props.comentario }
                    updateInputs = { this.props.updateInputs }
                    disabled_comment = { disabled_comment }
                    enviarComentario = { this.props.enviarComentario }
                    editarComentario = { this.props.editarComentario }
                    eliminarComentario = { this.props.eliminarComentario }
                />

            <div className="separator"></div>

            <AttachedFilesBox
                    files={ tiquetesaereo.get('adjuntos').filter(adjunto => !adjunto.get('documento_id')) }
                    root='solicitud'
                    removeFiles = { this.props.removeSolicitudTiqutesAereos }
                    updateInputs = { this.props.updateInputs }
                    obj={ tiquetesaereo }
                    check={ 'solicitud' }
                    disabledAttach = {true}
            />

            <div className="separator"></div>

            <BoxSection title="Pasajeros">

            {tiquetesaereo.getIn(['viaje', 'pasajeros']).map((p,i) => {
                if (can_edit && tiquetesaereo.get('estado') < 4 && tiquetesaereo.get('estado') != 0) {
                    return <PasajeroEdicion key={`Fragment[${i}]`} p={p} i={i} updateInputs={this.props.updateInputs} handleOpenSelectorAddPasajero={this.handleOpenSelectorAddPasajero}
                                            displayModalAddFile={this.props.displayModalAddFile} validateCaducidadPasaporte={this.props.validateCaducidadPasaporte}
                                            asistencia_vajero={asistencia_vajero} tipo_viaje={tiquetesaereo.getIn(['viaje', 'tipo_viaje'])}  tipos_identificacion = {tipos_identificacion}  />
                }
                return <PasajeroLectura key={ `Fragment[${i}]` } p={p} i={i} downloadFile={this.props.downloadFile} asistencia_vajero={asistencia_vajero}/>
            })}

            </BoxSection>
            <ModalAddFile action={ () => flagAdjunto ? this.props.editPassportFile() : this.props.addFileAdjunto() } />
            <ModalSelectorFromList />
            <ModalSelectorAirport />
            <ModalSelectVersion />


        </Fragment>
        )
	}
}

function mapStateToProps(state) {
    return {
        id: state.tiquetesaereo.get('id'),
        tiquetesaereo: state.tiquetesaereo.get('solicitud'),
        aprobadores: state.tiquetesaereo.get('aprobadores'),
        user: state.common.get('user'),
        comentario: state.tiquetesaereo.get('comentario'),
        enums: state.common.get('enums').toJS(),
        flagAdjunto: state.tiquetesaereo.get('flagAdjunto'),
        adjuntos: state.tiquetesaereo.get('adjuntos')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        addOrigen: (path,query) => dispatch(addOrigen(path,query)),
        addDestino: (path,query) => dispatch(addDestino(path,query)),
        addCencoSolicitud: () => dispatch(addCencoSolicitud()),
        removeCenco: () => dispatch(removeCenco()),
        addTrayecto: () => dispatch(addTrayecto()),
        addPasajero: (path) => dispatch(addPasajero(path)),
        editPassportFile: () => dispatch(editPassportFile()),
        displayModalAddFile: (show, title, mode, file, index) => dispatch(displayModalAddFile(show, title, mode, file, index)),
        removeTrayectos: () => dispatch(removeTrayectos()),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        showModalSelector: (title, fields, url, action, filter=null) => dispatch(showModalSelector(title, fields, url, action, filter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        validateCaducidadPasaporte: (value) => dispatch(validateCaducidadPasaporte(value)),
        showModalSelectorUrlAirports: (title, fields, url, action, customFilter) => dispatch(showModalSelectorUrlAirports(title, fields, url, action, customFilter)),
        enviarComentario: () => dispatch(enviarComentario()),
        editarComentario: (id) => dispatch(editarComentario(id)),
        eliminarComentario: (id) => dispatch(eliminarComentario(id)),
        removeSolicitudTiqutesAereos: () => dispatch(removeSolicitudTiqutesAereos()),
        addFileAdjunto: () => dispatch(addFileAdjunto()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(General)



// WEBPACK FOOTER //
// ./src/components/TiquetesAereos/General.jsx